export function formatBold(v) {
    if (v === "" || (Array.isArray(v) && v.length === 0)) return "";
    return `**${Array.isArray(v) ? v.join(", ") : v}**`;
}

export function formatDate(dateValue) {
    if (!dateValue) return "";
    if (dateValue instanceof Date && !Number.isNaN(dateValue.getTime())) {
        const day = String(dateValue.getDate()).padStart(2, "0");
        const month = String(dateValue.getMonth() + 1).padStart(2, "0");
        const year = dateValue.getFullYear();
        return `${day}/${month}/${year}`;
    }
    const [year, month, day] = String(dateValue).split("-");
    if (!year || !month || !day) return "";
    return `${day}/${month}/${year}`;
};